Wee.routes.addFilter({
	'isPaginated': function(seg) {
		console.log(/^p\d+$/.test(seg));
		return /^p\d+$/.test(seg);
	},
	'notPaginated': function(seg) {
		return seg && ! /^p\d+$/.test(seg);
	}
});

Wee.routes.map({
	'$any': [
		'gallery',
		'categoriesGrid',
		'testimonialSwiper'
	],
	'$any:unload': [
		'gallery:unload',
		'testimonialSwiper:unload'
	],
	'$any:once': [
		'common',
		'header',
		'nav',
		'search'
	],
	'funding': {
		'$any': 'funding',
		'$any:unload': 'funding:unload',
		'$slug': [
			'copyUrl',
			'download'
		],
		'$slug:unload': [
			'copyUrl:unload',
			'download:unload'
		]
	},
	'careers': {
		'$any': 'autocompleteJobs',
	},
	'news': {
		'$any': 'news',
		'$any:unload': 'news:unload'
	},
	'research-articles': {
		'$any': 'research',
		'$any:unload': 'research:unload'
	},
	'brands': 'brands',
	'brands:unload': 'brands:unload',
	'our-people': [
		'detailSlides'
	],
	'nds': {
		'map': 'map',
		'map:unload': 'map:unload'
	},
	'research': {
		'our-scholar-network': 'detailSlides'
	},
	'professional-development': 'cfpd',
	'events': {
		'$root': 'eventsIndex',
		'$root:unload': 'eventsIndex:unload',
		'$slug:isPaginated': 'eventsIndex'
	},
	'our-heritage': 'heritage',
	'our-heritage:unload': 'heritage:unload'
});

Wee.ready('routes:run');
